import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/agenda'
import { graphClient } from './auth'
import { notifyError } from '../../utils/notify'

function* getUserAgenda() {
  try {
    const res = yield graphClient
      .api('/me/events?top=50')
      /* .select('subject,body,bodyPreview,organizer,attendees,start,end,location,onlineMeeting,isCancelled,isAllDay') */
      .get()

    console.tron.log('getUserAgenda res', res)

    yield put({
      type: Types.GET_USER_AGENDA_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar sua agenda. Tente novamente mais tarde.')
    yield put({
      type: Types.GET_USER_AGENDA_FAILED,
    })
  }
}

export const agendaSagas = [
  takeLatest(Types.GET_USER_AGENDA_REQUESTED, getUserAgenda),
]
